import { useLocation, useParams } from "react-router-dom";
import { useLastPath } from "../../core/hooks/useLastPath";
import { useSlugs } from "../../core/hooks/useSlugs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "./Link";
import { BreadcrumbItem } from "../models/BreadcrumbItem";

interface BreadcrumbProps {
  breadcrumb: BreadcrumbItem;
  isRoot?: boolean;
  path: string;
}

export const Breadcrumb = ({
  breadcrumb,
  isRoot,
  path,
}: BreadcrumbProps) => {
  const location = useLocation();
  const parts = location.pathname.split("/");
  const lastPath = useLastPath();
  const matchPath = useLastPath(path);
  const {brandSlug, locationSlug} = useSlugs();
  const params = useParams();

  const isParam = breadcrumb.path.startsWith(":");
  const match = isParam && Object.keys(params).includes("*")
    ? params["*"] ?? matchPath
    : matchPath;
  const matches = match.split("/");
  const lastMatch = matches.length
    ? matches[matches.length - 1]
    : match;

  if ((!parts.includes(lastMatch) && !breadcrumb.alwaysShow) || (isRoot && lastPath === lastMatch)) {
    return null;
  }

  const title = isParam && breadcrumb.title === breadcrumb.path
    ? lastMatch
    : breadcrumb.title;
  const pathParams = path.split("/").filter(p => p.startsWith(":"));

  let to = path;
  pathParams.forEach(p => {
    to = to.replace(p, params[p.slice(1)] ?? "0");
  });

  return (
    <>
      {
        !isRoot &&
        !breadcrumb.neverShow &&
        <span className="text-unleashed-pink px-2">
          <FontAwesomeIcon icon={faChevronRight}/>
        </span>
      }
      {
        lastPath === lastMatch ? (
          <span className="text-sm">{title}</span>
        ) : (
          <>
            {!breadcrumb.neverShow &&
            <Link variant="none" className="underline text-sm" to={to}
              text={breadcrumb.title}/>
            }
            {
              breadcrumb.children &&
              breadcrumb.children?.map((c, i) =>
                <Breadcrumb key={i} breadcrumb={c}
                  path={c.path.startsWith("/") ? `/${brandSlug}/${locationSlug}${c.path}` : `${path}/${c.path}`}/>)
            }
          </>
        )
      }
    </>
  );
};
